<template>
    <BreadCrumb PageTitle="Liste des Demandes" />
    <ListeDemande />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeDemande from "../../components/Demande/ListeDemande.vue";
  
  export default defineComponent({
    name: "ListeDemandePage",
    components: {
      BreadCrumb,
      ListeDemande,
    },
  });
  </script>